// TSS vite/04 §"Endpoint paths". baseURL already includes /api/v1.

export const userPaths = {
    list:   ()   => 'admin/users',
    detail: (id) => `admin/users/${id}`,
    role:   (id) => `admin/users/${id}/role`, // cambio de rol (users:admin, único camino)
};
